import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useLoginMutation } from 'api/adminApi';

import styles from './style.module.scss';

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [login, { isLoading }] = useLoginMutation();
    const navigate = useNavigate();

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (isLoading) {
            return;
        }

        try {
            await login({ email, password }).unwrap();

            navigate('/', { replace: true });
        } catch (error) {
            toast.error('Неверная почта или пароль');
        }
    };

    return (
        <div className={styles.page}>
            <form
                className={styles.form}
                onSubmit={handleSubmit}
            >
                <h1 className={styles.title}>KasCapital Admin</h1>

                <label className={styles.label}>
                    Email
                    <input
                        type='email'
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        className={styles.input}
                        required
                    />
                </label>

                <label className={styles.label}>
                    Пароль
                    <input
                        type='password'
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        className={styles.input}
                        required
                    />
                </label>

                <button
                    type='submit'
                    className={styles.button}
                    disabled={isLoading}
                >
                    {isLoading ? 'Входим…' : 'Войти'}
                </button>
            </form>
        </div>
    );
};
